import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { PlinthFinishFields } from '@/components/features/finishes/PlinthFinishFields'

interface PlinthFinishSectionProps {
  // General finish from project defaults
  generalFinish?: {
    material?: string
    materialSameAsDoor: boolean
    color?: string
    colorSameAsDoor: boolean
    height?: number
  }
  
  // Current values
  useGeneral: boolean
  customMaterial?: string
  customMaterialSameAsDoor?: boolean
  customColor?: string
  customColorSameAsDoor?: boolean
  customHeight?: number
  
  // Callbacks
  onUseGeneralChange: (useGeneral: boolean) => void
  onCustomMaterialChange: (material: string) => void
  onCustomMaterialSameChange: (same: boolean) => void
  onCustomColorChange: (color: string) => void
  onCustomColorSameChange: (same: boolean) => void
  onCustomHeightChange: (height: number) => void
  
  // Options for combobox
  materialOptions?: string[]

  // Dialog control (headless mode)
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function PlinthFinishSection({
  generalFinish: _generalFinish,
  useGeneral,
  customMaterial = '',
  customMaterialSameAsDoor = true,
  customColor = '',
  customColorSameAsDoor = true,
  customHeight = 10,
  onUseGeneralChange,
  onCustomMaterialChange,
  onCustomMaterialSameChange,
  onCustomColorChange,
  onCustomColorSameChange,
  onCustomHeightChange,
  materialOptions = ['Stratifié', 'Mélamine', 'MDF', 'Aluminium', 'PVC', 'Autre'],
  open,
  onOpenChange,
}: PlinthFinishSectionProps) {
  return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Finition socle</DialogTitle>
          </DialogHeader>

          <div className="py-4 space-y-4">
            <div className="space-y-2">
              <Label>Mode</Label>
              <div className="flex gap-4 text-sm">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    checked={useGeneral}
                    onChange={() => onUseGeneralChange(true)}
                    className="w-4 h-4"
                  />
                  <span>Finition de base</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    checked={!useGeneral}
                    onChange={() => onUseGeneralChange(false)}
                    className="w-4 h-4"
                  />
                  <span>Spécifique</span>
                </label>
              </div>
              
            </div>

            {!useGeneral && (
              <div className="space-y-3">
                <p className="text-xs text-muted-foreground">
                  Définissez ici la finition du socle (matériau, coloris, hauteur).
                </p>
                <PlinthFinishFields
                  material={customMaterial}
                  materialSameAsDoor={customMaterialSameAsDoor}
                  onMaterialChange={onCustomMaterialChange}
                  onMaterialSameChange={onCustomMaterialSameChange}
                  color={customColor}
                  colorSameAsDoor={customColorSameAsDoor}
                  onColorChange={onCustomColorChange}
                  onColorSameChange={onCustomColorSameChange}
                  height={customHeight}
                  onHeightChange={onCustomHeightChange}
                  materialOptions={materialOptions}
                />
              </div>
            )}
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Annuler
            </Button>
            <Button
              type="button"
              onClick={() => onOpenChange(false)}
              disabled={!useGeneral && !customMaterialSameAsDoor && !customMaterial}
            >
              Appliquer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  )
}
